module.exports = __webpack_public_path__ + "static/media/home-background.1ef0e811.jpg";